<template>
  <div v-loading="loading" class="material-audio-upload">
    <el-divider></el-divider>

    <el-form
      label-position="left"
      :model="formData"
      :rules="rules"
      label-width="90px"
      ref="ruleForm"
    >
      <el-form-item label="上传音频:" prop="upload">
        <el-upload
          action="#"
          :before-upload="beforeUpload"
          :http-request="httpRequest"
          :limit="1"
          :on-remove="onRemove"
        >
          <el-button size="small">上传音频</el-button>
          <div slot="tip" class="el-upload__tip">（请上传20m以下的音频）</div>
        </el-upload>
        <el-input v-model="formData.upload" style="display: none"></el-input>
      </el-form-item>
      <el-form-item label="标题:" prop="title">
        <el-input v-model="formData.title" style="width: 700px" maxlength="30">
          <template slot="append">{{ postfix }}</template>
        </el-input>
      </el-form-item>
      <el-form-item label="公众号:" prop="public">
        <el-select v-model="formData.public" multiple class="select" style="width: 700px">
          <template v-for="item in publicList">
            <el-option :key="item.app_id" :label="item.app_name" :value="item.app_id" />
          </template>
        </el-select>
      </el-form-item>
      <el-form-item label="企业应用:" prop="agents">
        <el-select v-model="formData.agents" multiple class="select" style="width: 700px">
          <template v-for="item in agentList">
            <el-option
              :key="item.agent_id"
              :label="item.agent_name"
              :value="item.agent_id"
              :disabled="+item.close === 1"
            />
          </template>
        </el-select>
      </el-form-item>
    </el-form>

    <div class="btns">
      <el-button type="primary" class="btn-width" @click="save">保存</el-button>
      <el-button
        v-show="showback"
        class="btn-width"
        @click="
          () => {
            closeComp('back');
          }
        "
      >
        取消
      </el-button>
    </div>
  </div>
</template>
<script>
import { CosMixin } from '@/mixins/cos';
import { EyaoSaaSSynCreateMaterialApi } from '@/api/releaseManagement';
import { postfixFun } from '@/utils/util';
export default {
  name: 'MaterialManagementAudioUpload',
  components: {},
  mixins: [CosMixin],
  data() {
    return {
      type: 3,
      showback: true, // 是否新打开的页面(是为false)
      loading: false, // 加载
      formData: {
        upload: '',
        title: '',
        agents: [],
        public: [],
      },
      rules: {
        upload: [{ required: true, message: '请选择' }],
        title: [{ required: true, message: '请输入' }],
        agents: [{ required: false, message: '请选择' }],
        public: [{ required: false, message: '请选择' }],
      },
      // 上传列表
      list: [],
      postfix: '', // 标题后缀
    };
  },
  computed: {
    publicList() {
      return this.$store.getters['user/getPublishList'];
    },
    // 缓存企业应用列表
    agentList() {
      return this.$store.state.user.managerLogin.agent_list;
    },
  },
  created() {
    this.$store.dispatch('user/getManagerLogin');
    this.showback = !this.isNewBlank();
  },
  methods: {
    // 上传校验
    beforeUpload(file) {
      let isSupport = true;
      console.log('文件后缀');
      console.log(file.name.substr(file.name.lastIndexOf('.') + 1));
      const regExp = 'mp3|wma|wav|amr';
      if (!new RegExp(`(${regExp})`, 'i').test(file.name.substr(file.name.lastIndexOf('.') + 1))) {
        this.$message.error(`上传音频仅支持 mp3/wma/wav/amr 格式!`);
        isSupport = false;
      }

      const isSize = file.size / 1024 / 1024 < 20;
      if (!isSize) {
        this.$message.error('上传音频大小不能超过20MB!');
      }
      const res = isSize && isSupport;
      return res;
    },
    // 请求处理(覆盖element默认行为, 配置请求所需的参数)
    httpRequest(data) {
      const obj = {
        file: data.file,
        url: undefined, // cos地址
        cos_status: 'ready', // cos上传状态 ready(准备上传) error(上传错误) success(上传成功)
        upload_status: 'ready', // 服务器上传状态 ready(准备上传) error(上传错误) success(上传成功)
      };
      this.list.push({ ...obj });
      this.formData.upload = 'true';

      const { prefix, postfix } = postfixFun(data.file.name);
      this.formData.title = prefix;
      this.postfix = postfix;

      // 默认选中所有下拉选项
      this.selectAll();
    },
    // 选中所有下拉选项
    selectAll() {
      const arr1 = [];
      this.publicList.forEach((e) => {
        arr1.push(e.app_id);
      });
      this.formData.public = arr1; // 默认选中公众号
      const arr2 = [];
      this.agentList.forEach((e) => {
        arr2.push(e.agent_id);
      });
      this.formData.agents = arr2; // 默认选中企业应用
    },
    onRemove() {
      this.list = [];
      this.formData.upload = '';
    },
    // 保存 先请求cos, 再请求服务器
    // 1. 上传cos , 上传错误, 改变失败状态
    // 2. 上传服务器, 上传错误, 改变失败状态
    save() {
      const that = this;
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (that.formData.public.length === 0 && that.formData.agents.length === 0) {
            that.$message.warning('请至少选择一个公众号或企业应用');
            return;
          }
          that.loading = true;
          const resArr = await that.requestServer(await that.getCosUrl(this.list));
          that.list = resArr;

          // 判断是否上传成功
          let count = 0;
          const ilen = resArr.length;
          for (let i = 0; i < ilen; i++) {
            const e = resArr[i];
            if (e.cos_status === 'success' && e.upload_status === 'success') {
              count += 1;
            }
          }
          // 全部上传成功
          setTimeout(() => {
            if (count === ilen) {
              that.closeComp('save');
              that.$message.success('保存成功');
              that.loading = false;
            } else {
              that.$message.error(`保存失败, 请重新保存`);
              that.loading = false;
            }
          }, 0);
        }
      });
    },
    // 上传转换获取cos地址
    getCosUrl(arr) {
      const arrTemp = [...arr];
      return new Promise(async (resolve) => {
        for (let i = 0, ilen = arrTemp.length; i < ilen; i++) {
          const e = arrTemp[i];
          // 准备上传和上传失败可再上传
          if (e.cos_status === 'ready' || e.cos_status === 'error') {
            const cosParams = {
              fileObject: e.file,
            };
            try {
              const res = await this.putCosObject(cosParams);

              e.url = res.data;
              e.cos_status = res ? 'success' : 'error';
            } catch (error) {
              e.cos_status = 'error';
            }
          }
        }
        resolve(arrTemp);
      });
    },
    // 请求服务器
    async requestServer(arr) {
      const { formData, type } = this;
      const arrTemp = [...arr];
      return new Promise(async (resolve) => {
        for (let i = 0; i < arrTemp.length; i++) {
          const e = arrTemp[i];
          if (
            e.cos_status === 'success' ||
            e.upload_status === 'ready' ||
            e.upload_status === 'error'
          ) {
            try {
              // cos上传失败, mate_data为空, 不走服务器
              if (!e.url) break;

              // 提取id
              const agents = [];
              this.agentList.forEach((item1) => {
                formData.agents.forEach((item2) => {
                  if (item1.agent_id === item2) {
                    agents.push({ agent_id: item1.agent_id, agent_name: item1.agent_name });
                  }
                });
              });
              // 公众号提取id
              const apps = [];
              this.publicList.forEach((item1) => {
                formData.public.forEach((item2) => {
                  if (item1.app_id === item2) {
                    apps.push({ app_id: item1.app_id, app_name: item1.app_name });
                  }
                });
              });
              const res = await EyaoSaaSSynCreateMaterialApi({
                mate_infos: [
                  {
                    mate_type: type,
                    mate_data: e.url,
                    mate_name: formData.title + this.postfix,
                    agents,
                    apps,
                  },
                ],
              });
              if (!res.error) {
                e.upload_status = 'success';
              } else {
                e.upload_status = 'error';
              }
            } catch (error) {
              e.upload_status = 'error';
            }
          }
        }
        resolve(arrTemp);
      });
    },
    // 隐藏组件  val = 'back'(返回)  'save'(保存或发布)
    closeComp() {
      // 如果是素材库管理, 跳转回素材库管理
      if (this.$route.path.includes('materialManagement')) {
        this.g_tourl(`/saas/materialManagement.html`);
      } else {
        console.log('here');
      }
    },
    // 是否新标签页
    isNewBlank() {
      const { query } = this.$route;
      // 判断是否新打开的页面
      return query.type === 'newWindow';
    },
  },
};
</script>
<style lang="scss" scoped>
.material-audio-upload {
  .back {
    height: 84px;
    line-height: 84px;
    font-size: 18px;
    color: #313233;
    cursor: pointer;
    span {
      float: left;
      margin-right: 16px;
    }
    .gray {
      font-size: 16px;
      color: #606266;
    }
  }
  .btns {
    text-align: center;
    margin-top: 100px;
    .btn-width {
      //   margin-left: 0;
      width: 148px;
      height: 48px;
    }
  }
}
</style>
